import { H6 } from "@blueprintjs/core";
import React from "react";

export function Title({ departmentName }: { departmentName: string }) {
  return <H6 className={"single-dept-recos--title"}>{departmentName}</H6>;
}
